/** @jsxImportSource react */
import {
  Bed,
  FamilyStroke,
  HomeSmallStroke,
  Payment,
  Spa,
} from '@sly/icons/react';

export const alChecklistData = {
  'General observations': {
    icon: <HomeSmallStroke />,
    items: [
      'The community is clean, well-maintained, and odor-free',
      'The overall atmosphere feels friendly, positive and promotes social interaction among residents',
      'Outdoor spaces are well-kept and safe for residents, with secure walking paths, gardens, or patios',
      'There is a focus on safety, with proper signage, handrails, and accessible paths',
      'Residents are engaged in activities and appear happy',
      'Pet-friendly environment',
      'Visitation policy is convenient and flexible',
      'Clear emergency response protocols are in place',
    ],
  },
  'Personal services': {
    icon: <Spa />,
    items: [
      'Assistance with daily living activities is provided',
      'Medication management services are available',
      'Care plans are reviewed and updated regularly to meet changing needs',
      'Housekeeping, laundry, and linen services are provided',
      'Meals are nutritious, appealing, and accommodate dietary restrictions and preferences',
      'Transportation for medical appointments, social activities',
      'Activities are designed to cater to different levels of physical ability and cognitive function',
      'Fitness and wellness programs are available to residents',
    ],
  },
  Staffing: {
    icon: <FamilyStroke />,
    items: [
      'A licensed nurse available on-site',
      'Staff are warm, respectful, and caring to residents',
      'Background checks are conducted on all staff members',
      'Staff turnover is low',
      'Staff have experience with your specific care needs',
      "You're comfortable with the staff-to-resident ratio",
      'Staff are responsive assisting residents, especially in common areas',
      'There are dedicated staff for activities and engagement',
    ],
  },
  'Living units': {
    icon: <Bed />,
    items: [
      'Room is clean and well-maintained',
      "Room size is adequate for resident's needs",
      'Private bathroom in unit',
      'Residents are allowed to personalize their living space with decorations, pictures, and other personal items',
      'Rooms are equipped with an emergency call system',
      'Units include adequate natural lighting and ventilation',
      'Temperature is comfortable and controllable',
      'Unit is furnished',
    ],
  },
  Finances: {
    icon: <Payment />,
    items: [
      'Base monthly fee and included services is clearly defined',
      'All extra fees for additional services are transparent',
      'Families receive detailed monthly invoices that are easy to understand and review',
      'The policy on handling missed or late payments is clear',
      'Refund policies are clearly outlined for cases of resident departure or death',
      "Financial assistance such as Medicaid or veterans' benefits are available",
    ],
  },
};

export const ilChecklistData = {
  'General observations': {
    icon: <HomeSmallStroke />,
    items: [
      'The community is clean, well-maintained, and odor-free',
      'The overall atmosphere feels friendly, positive and promotes social interaction among residents',
      'Outdoor spaces are well-kept and safe for residents, with secure walking paths, gardens, or patios',
      'There is a focus on safety, with proper signage, handrails, and accessible paths',
      'Residents are engaged in activities and appear happy',
      'Pet-friendly environment',
      'Visitation policy is convenient and flexible',
      'Clear emergency response protocols are in place',
    ],
  },
  'Personal services': {
    icon: <Spa />,
    items: [
      'Housekeeping, laundry, and linen services are provided',
      'Meals are nutritious, appealing, and accommodate dietary restrictions and preferences',
      'Transportation for social outings, medical appointments is available',
      'Fitness and wellness programs are available to residents',
      'Frequently scheduled events, activities, and outings for residents',
      'Social spaces for residents to gather at such as lounges, game rooms, libraries, or gardens',
      'Concierge services are available for assistance with errands, scheduling, and daily needs',
    ],
  },
  Staffing: {
    icon: <FamilyStroke />,
    items: [
      'Staff are warm, respectful, and caring to residents',
      'Background checks are conducted on all staff members',
      'Staff turnover is low',
      'Staff are responsive assisting residents, especially in common areas',
      'There are dedicated staff for activities and engagement',
      'On-site medical staff or access to nearby medical professionals is available',
      'Staff are trained in conflict resolution and managing resident and family concerns',
    ],
  },
  'Living units': {
    icon: <Bed />,
    items: [
      'Room is clean and well-maintained',
      "Room size is adequate for resident's needs",
      'Private bathroom in unit',
      'Residents are allowed to personalize their living space with decorations, pictures, and other personal items',
      'Rooms are equipped with an emergency call system',
      'Units include adequate natural lighting and ventilation',
      'Temperature is comfortable and controllable',
      'Unit is furnished',
    ],
  },
  Finances: {
    icon: <Payment />,
    items: [
      'Base monthly fee and included services is clearly defined',
      'All extra fees for additional services are transparent',
      'Families receive detailed monthly invoices that are easy to understand and review',
      'The policy on handling missed or late payments is clear',
      'Refund policies are clearly outlined for cases of resident departure or death',
      "Financial assistance such as Medicaid or veterans' benefits are available",
    ],
  },
};

export const mcChecklistData = {
  'General observations': {
    icon: <HomeSmallStroke />,
    items: [
      'The community is clean, well-maintained, and odor-free',
      'The overall atmosphere feels friendly, positive and promotes social interaction among residents',
      'Outdoor spaces are well-kept and safe for residents, with secure walking paths, gardens, or patios',
      'Monitoring systems are in place to prevent wandering',
      'Clear emergency response protocols are in place',
      'There is a focus on safety, with proper signage, handrails, and accessible paths',
      'Residents are engaged in activities and appear happy',
      'Visitation policy is convenient and flexible',
    ],
  },
  'Personal services': {
    icon: <Spa />,
    items: [
      'Personalized memory care plans are reviewed and updated regularly to reflect changing needs',
      'Assistance with daily living activities is provided',
      'Medication management services are available',
      'Housekeeping, laundry, and linen services are provided',
      'Meals are nutritious, appealing, and accommodate dietary restrictions and preferences',
      'Transportation for medical appointments, social outings',
      'Activities are designed to cater to different levels of physical ability and cognitive function',
      'Fitness and wellness programs are available to residents',
    ],
  },
  Staffing: {
    icon: <FamilyStroke />,
    items: [
      'Staff are experienced with memory-related behaviors',
      'Licensed staff available on-site 24/7',
      'Staff are warm, respectful, and caring to residents',
      'Background checks are conducted on all staff members',
      'Staff turnover is low',
      "You're comfortable with the staff-to-resident ratio",
      'Staff are responsive assisting residents in common areas and their personal units',
      'There are dedicated staff for activities and engagement',
    ],
  },
  'Living units': {
    icon: <Bed />,
    items: [
      'Room is clean and well-maintained',
      'Rooms are equipped with an emergency call system',
      'Windows are secure and provide adequate natural lighting',
      'Residents are allowed to personalize their living space with decorations, pictures, and other personal items',
      'Secured entry and exit points help prevent wandering',
      "Room size is adequate for resident's needs",
      'Temperature is comfortable and controllable',
      'Unit is furnished',
    ],
  },
  Finances: {
    icon: <Payment />,
    items: [
      'Base monthly fee and including all care services are clearly defined',
      'All extra fees for additional care services are transparent',
      'Families receive detailed monthly invoices that are easy to understand and review',
      'The policy on handling missed or late payments is clear',
      'Refund policies are clearly outlined for cases of resident departure or death',
      "Financial assistance such as Medicaid or veterans' benefits are available",
    ],
  },
};
